import * as z from "zod";

export const hostnameGlobPattern = /^[a-zA-Z0-9_*.-]+$/;
export const invalidHostnameMessage =
  "Enter a hostname pattern without a scheme, port, path, or whitespace, e.g. *.example.com.";

export const destinationSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("hostnameGlob"),
    pattern: z.string().regex(hostnameGlobPattern, invalidHostnameMessage),
  }),
  z.object({
    type: z.literal("cidr"),
    // Match Destination::compile so invalid CIDRs cannot make deny rules silently fail open.
    range: z.union([z.cidrv4(), z.cidrv6()]),
  }),
]);

// The exit node's dial ACL (`DESTINATION_CIDRS`) is derived from the network's
// CIDR routes, so it has to be recomputed whenever those routes change.
export function collectDestinationCidrs(
  routes: ReadonlyArray<{ destinationType: string; destination: string }>
): string {
  return routes
    .filter((r) => r.destinationType === "cidr")
    .map((r) => r.destination)
    .join(",");
}
